import React, { Component } from 'react'
import { connect } from 'react-redux';
import { fetchHours, fetchHoursSecondColumn } from '../../redux/actions';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import Map from '../../components/Map/Map.js';
import Address from '../../components/Address.js';
import NewsLetter from '../../components/NewsLetter/NewsLetter.js';
import './Footer.css';
import Hours from '../../components/Hours';
import { Link } from 'react-router-dom';

class Footer extends Component {
  componentDidMount() {
    if (!this.props.hours) {
      this.props.fetchHours(this.props.intl.locale);
    }

    if (!this.props.hoursSecondColumn) {
      this.props.fetchHoursSecondColumn(this.props.intl.locale);
    }
  }

  render() {
    return (
        <div>
            <Map/>
            <footer className="app-footer">
              <Address/>
              <div>
                <h4><FormattedMessage id="footer.openTitle" /></h4>
                <Hours text={this.props.hours}/>
                <p><FormattedMessage id="footer.otherTimes" /></p>
                <Link to="/contact" className="footer-link"><FormattedMessage id="footer.specialHours" /></Link>
              </div>
              <div>
                <h4><FormattedMessage id="footer.openTitle" /></h4>
                <Hours text={this.props.hoursSecondColumn}/>
              </div>
              <div>
                <NewsLetter/>
                <h4>&nbsp;</h4>
                <a href={'https://www.w-restaurants.fi/'} className="footer-link">W-Restaurants Oy</a>
                <a href={'https://www.w-restaurants.fi/asiakasrekisterin-tietosuojaseloste'} className="footer-link"><FormattedMessage id="footer.privacyPolicy" /></a>
                <a href={'https://www.w-restaurants.fi/b2b-suoramarkkinoinnin-tietosuojaseloste'} className="footer-link"><FormattedMessage id="footer.webshopPrivacyPolicy" /></a>
                <a href={'https://www.w-restaurants.fi/verkkokaupan-toimitusehdot'} className="footer-link"><FormattedMessage id="footer.webshopTerms" /></a>
                <a href="https://www.oivahymy.fi/hae-yrityksia/#text=levain" target="_blank" rel="noopener noreferrer" className="footer-link">{this.props.intl.messages["general.oiva"]}</a>
              </div>
            </footer>
        </div>
    )
  }
}

Footer.propTypes = {
  intl: intlShape.isRequired,
}

const mapStateToProps = state => ({
  hours: state.hours,
  hoursSecondColumn: state.hoursSecondColumn
});

const mapDispatchToProps = {
  fetchHours,
  fetchHoursSecondColumn,
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(Footer));



// WEBPACK FOOTER //
// ./src/containers/Footer/Footer.js